import "./WhyChooseService.css";

import {
  FaAward,
  FaBasketballBall,
  FaShieldAlt,
  FaHardHat,
  FaClock,
  FaHandshake,
} from "react-icons/fa";

const icons = [
  FaAward,
  FaBasketballBall,
  FaShieldAlt,
  FaHardHat,
  FaClock,
  FaHandshake,
];

const WhyChooseService = ({ data }) => {
  const whyChoose = data?.whyChoose;

  if (!whyChoose) {
    return null;
  }

  return (
    <section className="why-service">
      <div className="why-service-container">
        <div className="why-service-heading">
          <span className="section-tag-why">{whyChoose.tag}</span>

          <h2>{whyChoose.title}</h2>

          <p>{whyChoose.description}</p>
        </div>

        <div className="why-service-grid">
          {whyChoose.features.map((item, index) => {
            const Icon = icons[index] || FaAward;

            return (
              <div className="why-service-card" key={index}>
                <div className="why-icon">
                  <Icon />
                </div>

                <h3>{item.title}</h3>

                <p>{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseService;
